"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.controls.knowledgePicker.label': '选择知识',
    'ai.controls.knowledgePicker.show': '使用知识库',
};
